import { useBalance } from 'wagmi'
import { useMemo } from 'react'
import { formatUnits } from 'viem'
import { IS_TESTNET } from '@/constants/walletConnectionConfig'
import { arbitrum, sepolia } from '@reown/appkit/networks'
import { USDC_ARBITRUM_ADDRESS } from '@/constants'

export function useSellTokenBalance(walletAddress: `0x${string}`) {
  // Determine which token and chain to use
  const tokenAddress = IS_TESTNET ? undefined : USDC_ARBITRUM_ADDRESS
  const chainId = IS_TESTNET ? sepolia.id : arbitrum.id

  // Fetch ETH balance for Sepolia or USDC for Arbitrum
  const {
    data: balanceData,
    isLoading: isBalanceLoading,
    refetch: refetchSellTokenBalance
  } = useBalance({
    address: walletAddress,
    chainId,
    token: tokenAddress
  })

  // Format the balance to return a readable value
  const sellTokenBalance = useMemo(
    () =>
      balanceData?.value
        ? parseFloat(formatUnits(balanceData?.value, balanceData?.decimals))
        : 0,
    [balanceData?.value, balanceData?.decimals]
  )

  return { sellTokenBalance, isBalanceLoading, refetchSellTokenBalance }
}
